import { FC } from 'react';

interface DisposeConfirmDialogProps {
  disposeAction: 'dispose' | 'dispose-reissue';
  disposeSelectedIds: Set<string>;
  disposeReason: string;
  setDisposeReason: (v: string) => void;
  isDisposing: boolean;
  setShowDisposeConfirm: (v: boolean) => void;
  handleDispose: () => Promise<void>;
}

export const DisposeConfirmDialog: FC<DisposeConfirmDialogProps> = ({
  disposeAction,
  disposeSelectedIds,
  disposeReason,
  setDisposeReason,
  isDisposing,
  setShowDisposeConfirm,
  handleDispose,
}) => {
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="fixed inset-0 bg-black/40"
        onClick={() => !isDisposing && setShowDisposeConfirm(false)}
      />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900">
          {disposeAction === 'dispose' ? '쿠폰 폐기 확인' : '폐기 + 재발급 확인'}
        </h3>
        <p className="mt-2 text-sm text-gray-600">
          {disposeAction === 'dispose' ? (
            <>
              선택한 쿠폰{' '}
              <span className="font-bold">{disposeSelectedIds.size}건</span>을
              폐기합니다. 재발급 없이 폐기만 진행됩니다.
            </>
          ) : (
            <>
              선택한 쿠폰{' '}
              <span className="font-bold">{disposeSelectedIds.size}건</span>을
              폐기하고, 같은 순번으로 새 쿠폰을 재발급합니다.
            </>
          )}
        </p>
        <div className="mt-3 rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600">
          {disposeAction === 'dispose'
            ? '폐기된 쿠폰은 Disposed 상태로 변경됩니다. 나중에 별도로 재발행(additional) 후 승격할 수 있습니다.'
            : '폐기된 쿠폰은 Disposed 상태로 변경되며, 새 쿠폰이 isReissued로 즉시 생성됩니다.'}
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium text-gray-700">
            폐기 사유 <span className="text-gray-400">(선택)</span>
          </label>
          <textarea
            value={disposeReason}
            onChange={(e) => setDisposeReason(e.target.value)}
            placeholder="예: 잘못된 전달"
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-slate-400 focus:outline-none focus:ring-1 focus:ring-slate-400"
            rows={2}
          />
        </div>

        <div className="mt-5 flex gap-3">
          <button
            onClick={() => setShowDisposeConfirm(false)}
            disabled={isDisposing}
            className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
          >
            닫기
          </button>
          <button
            onClick={handleDispose}
            disabled={isDisposing}
            className={`flex-1 rounded-lg py-2.5 text-sm font-bold text-white disabled:opacity-50 ${
              disposeAction === 'dispose'
                ? 'bg-slate-600 hover:bg-slate-700'
                : 'bg-teal-600 hover:bg-teal-700'
            }`}
          >
            {isDisposing
              ? '처리중...'
              : disposeAction === 'dispose'
              ? '폐기 실행'
              : '폐기+재발급 실행'}
          </button>
        </div>
      </div>
    </div>
  );
};
